import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { ServiceItemsCatalogue } from "..";
import { ServicesCatalogue } from "..";
import { DepartmentsCatalogue } from "..";
import { ProvinceCatalogue } from "..";
import { RegionCatalogue } from "..";


export const CatalogueManagement = () => {

  const suhbeader = useSubheader();
  suhbeader.setTitle("Catalogue Management");
  
  return (
    <>
      <div className="row">
        <div className="col-12">
          <Switch>
            <Redirect
              from="/catalogue-management"
              exact={true}
              to="/catalogue-management/region"
            />
            <Route
              path="/catalogue-management/region"
              component={RegionCatalogue}
            />
            <Route
              path="/catalogue-management/provinces"
              component={ProvinceCatalogue}
            />
            <Route
              path="/catalogue-management/departments"
              component={DepartmentsCatalogue}
            />            
            <Route
              path="/catalogue-management/services"
              component={ServicesCatalogue}
            />
            <Route
              path="/catalogue-management/service-items"
              component={ServiceItemsCatalogue}
            />
          </Switch>
        </div>
      </div>
    </>
  );
};